import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AdoptionService } from '../../../services/adoption.service';
import { AdoptionQuiz } from './adoption-quiz.model';

/** Auto-shown after login: "Wusstest du schon..." — a picture + a short
 *  claim, checked by a small multiple-choice quiz. There is no cancel
 *  button by design; the answer buttons are the only way forward, and a
 *  wrong pick just rules that option out instead of blocking the user. */
@Component({
  selector: 'app-adoption-modal',
  templateUrl: './adoption-modal.component.html',
  styleUrl: './adoption-modal.component.scss',
})
export class AdoptionModalComponent implements OnInit {
  @Input() quiz!: AdoptionQuiz;

  protected showBubble = false;
  protected attemptedWrong = new Set<number>();
  protected solved = false;

  constructor(
    protected dialogRef: NbDialogRef<AdoptionModalComponent>,
    private adoptionService: AdoptionService,
  ) {}

  ngOnInit(): void {
    // Let the picture land first, then have Orbi "explain" it — matches
    // the requested beat: picture appears, then the speech bubble pops in.
    setTimeout(() => (this.showBubble = true), 600);
  }

  protected selectOption(index: number): void {
    if (this.solved || this.attemptedWrong.has(index)) {
      return;
    }

    if (this.quiz.options[index].correct) {
      this.solved = true;
      this.adoptionService.markSeen(this.quiz.slug);
      setTimeout(() => this.dialogRef.close(), 1100);
    } else {
      this.attemptedWrong.add(index);
    }
  }
}
